import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function About() {
  return (
    <div className="App">
      {/* Header Section */}
      <header 
        className="main-header"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/new-flowers.png)`
        }}
      >
        <div className="header-content">
          <div className="logo-section">
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img src="/images/dm-logo.png" alt="DM Logo" className="logo" />
            </Link>
            <div className="brand-text">
              <h1>
                <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <span className="first-name">DARIA</span><span className="last-name">MARMER</span>
                </Link>
              </h1>
              <p className="tagline">
                PRODUCT <strong>MANAGEMENT</strong> | PRODUCT <strong>STRATEGY</strong> | PRODUCT <strong>LOVE</strong>
              </p>
            </div>
          </div>
        </div>
        
        <nav className="main-nav">
          <ul>
            <li><Link to="/">HOME</Link></li>
            <li><Link to="/about" className="active">ABOUT</Link></li>
          </ul>
        </nav>
      </header>

      {/* About Content */}
      <main className="main-content">
        <div className="container">
          <div className="about-content">
            <h1>Meet Daria</h1>
            
            <div className="about-layout">
              <div className="about-text">
                <p>I am a B2B, B2C, GTM, Product strategy, data crunching, design loving Product Manager. I've worked at Klaviyo, HubSpot, LinkedIn and eBay, been the first PM of a company (twice), and grew with companies as they scaled from 30 to 100+ PMs (twice).</p>
                
                <p>My favorite software product is (currently) Libby. Favorite Hardware is my Kobo Libra. Product I'd most like to tear apart is Poshmark.</p>
                
                <p>In my spare time, I love to cook, play guitar and piano, and run.</p>
              </div>
              
              <div className="about-image">
                <img 
                  src="/images/IMG_2805.JPG" 
                  alt="Daria Marmer"
                  onError={(e) => {
                    // Fallback to a placeholder if the illustration doesn't exist
                    e.target.src = '/images/dm-logo.png';
                  }}
                />
              </div>
            </div>
            
            <Link to="/" className="back-link">← Back to Blog</Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="main-footer">
        <div className="footer-content">
          <p>&copy; 2025 Daria Marmer. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default About;